import React from 'react';
import { CircleCheck, CircleOff, Clock, RefreshCw, ShieldAlert } from 'lucide-react';
import StatusBadge from '../../../components/ui/StatusBadge';

const STATUS_PRESENTATION = {
  provisioned: {
    label: 'Aguardando registro',
    title: 'O connector ainda não consumiu o token de provisionamento',
    styleClass: 'bg-slate-100 text-slate-600 border-slate-200',
    icon: Clock,
  },
  active: {
    label: 'Ativo',
    title: 'Credencial válida e connector operando',
    styleClass: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    icon: CircleCheck,
  },
  rotating: {
    label: 'Rotação pendente',
    title: 'Segredo novo emitido, aguardando confirmação do connector',
    styleClass: 'bg-amber-50 text-amber-700 border-amber-200',
    icon: RefreshCw,
  },
  blocked: {
    label: 'Bloqueado',
    title: 'Identidade válida, operação suspensa',
    styleClass: 'bg-orange-50 text-orange-700 border-orange-200',
    icon: ShieldAlert,
  },
  revoked: {
    label: 'Revogado',
    title: 'Estado terminal: voltar a operar exige novo provisionamento',
    styleClass: 'bg-red-50 text-red-700 border-red-200',
    icon: CircleOff,
  },
};

function ConnectorStatusBadge({ status }) {
  const presentation = STATUS_PRESENTATION[status] || {
    label: status,
    styleClass: 'bg-slate-100 text-slate-600 border-slate-200',
  };

  return (
    <StatusBadge
      label={presentation.label}
      title={presentation.title}
      styleClass={presentation.styleClass}
      icon={presentation.icon}
    />
  );
}

export default ConnectorStatusBadge;
